// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gradegrid{display:grid;grid-template-columns:1fr 5fr;text-align:left}.selectgradebutton{height:70px;width:70px;background-color:var(--frame-color);border:1px solid grey;font-size:larger;margin:5px}.gradelabel{margin:25px 0 0 10px}.gradeinput{text-align:left;width:500px}.multilinelabel1{white-space:pre-wrap;max-width:100%}", ""]);
// Exports
module.exports = exports;
